var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-form-group',[_c('kt-form-label',{attrs:{"for":_vm.idf}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('kt-form-control',{attrs:{"disabled":"","value":_vm.val,"id":_vm.idf,"name":_vm.idf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }